import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuarterlyBalanceComponent } from './quarterly-balance.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, TranslateModule],
  exports: [QuarterlyBalanceComponent],
  declarations: [QuarterlyBalanceComponent],
})
export class QuarterlyBalanceModule {}
